import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageOutlined = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 18 14",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.13 4.81a.94.94 0 1 1-1.88 0 .94.94 0 0 1 1.88 0Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M.88 1.38c0-.7.55-1.25 1.25-1.25h13.75c.69 0 1.24.55 1.24 1.25v11.25c0 .69-.55 1.24-1.25 1.24H2.13c-.7 0-1.25-.55-1.25-1.24V1.37Zm15 0v8.49l-2.24-2.24a1.25 1.25 0 0 0-1.78 0l-1.6 1.6-.01.01-3.49-3.49a1.25 1.25 0 0 0-1.77 0L2.12 8.62V1.38h13.75ZM2.12 12.63v-2.25l3.75-3.74 3.5 3.48a1.25 1.25 0 0 0 1.77 0l1.6-1.6.01-.01 3.13 3.12v1H2.12Z",
		clipRule: "evenodd"
	})]
});
export default SvgImageOutlined;
